import React, {useReducer} from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {setUiPopupState} from "../../../actions/A_Popups";
import {UI_POPUP_TYPES} from "../../../reducers/R_Popups";
import UIPopupContext, {uiPopupContextReducer} from "./UIPopupContext";
import ReferralPopupContent from "./ReferralPopup/ReferralPopupContent";
import JobAssociateFabricatorPopupContent
  from "../../JobBoard/jobAssociateFabricatorPopup/JobAssociateFabricatorPopupContent";
import AccountTwoFaPopupContent from "../../Account/AccountTwoFa/AccountTwoFaPopupContent";
import ACHCredentialsPopupContent from "../../Account/ACHComponents/ACHCredentialsPopupContent";
import ACHContractPopupContent from "../../Account/ACHComponents/ACHContractPopupContent";
import DiscountsPopupContent from "../../Discounts/DiscountsPopup/DiscountsPopupContent";

const getContent = (uiPopupState) => {
  switch (uiPopupState.type) {
    case UI_POPUP_TYPES.referral:
      return <ReferralPopupContent/>
    case UI_POPUP_TYPES.associateJobFabricator:
      return <JobAssociateFabricatorPopupContent/>
    case UI_POPUP_TYPES.fabricatorTwoFA:
      return <AccountTwoFaPopupContent/>
    case UI_POPUP_TYPES.accountACHCredentials:
      return <ACHCredentialsPopupContent/>
    case UI_POPUP_TYPES.accountACHContract:
      return <ACHContractPopupContent/>
    case UI_POPUP_TYPES.discountsDisplayOptions:
      return <DiscountsPopupContent/>
    default:
      return null
  }
}


const UIPopup = (props) => {

  const {uiPopupState, setUiPopupState, intl} = props;

  const [uiPopupContext, uiPopupDispatch] = useReducer(uiPopupContextReducer, {...uiPopupState.context});

  const closePopup = () => {
    setUiPopupState({opened: false});
  };

  return (
    <UIPopupContext.Provider value={{uiPopupContext, uiPopupDispatch}} >
      <div className={"ui-popup ui-popup--common flex flex--column " + uiPopupState.className} style={uiPopupState.style}>
        <button className="ui-popup-header__close" onClick={closePopup}/>
        {uiPopupState.headerTextId ? (
          <div className="ui-popup__header">
            <span className="ui-popup__header-title">
              <FormattedMessage id={uiPopupState.headerTextId}/>
            </span>
          </div>
        ) : null}
        {getContent(uiPopupState)}
        <div className="ui-popup-footer">
          {uiPopupState.buttons.map(button => {
            const disabled = button.isSaveButton && uiPopupContext.saveButtonDisabled;
            return (
              <button key={button.textId || "messageBox.buttons.cancel"}
                      className={(button.className || "ui-button5 ui-button5--wide text-uppercase ui-button5--blue")
                        + (disabled ? " ui-button5--disabled" : "")}
                      onClick={() => disabled ? null : button.onClick
                        ? button.onClick(closePopup, uiPopupContext, intl)
                        : closePopup()}>
                <FormattedMessage id={button.textId || "messageBox.buttons.cancel"}/>
              </button>
            )
          })}
        </div>
      </div>
    </UIPopupContext.Provider>
  )
};

UIPopup.propTypes = {
  uiPopupState: PropTypes.shape({
    opened: PropTypes.bool.isRequired,
    headerTextId: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    context: PropTypes.object,
    type: PropTypes.oneOf(Object.values(UI_POPUP_TYPES)),
    buttons: PropTypes.arrayOf(PropTypes.shape({
      textId: PropTypes.string,
      disabled: PropTypes.bool,
      onClick: PropTypes.func,
    }))
  })
}

const mapStateToProps = (store) => {
  const {uiPopupState} = store.popups;
  return {
    uiPopupState
  }
};

const mapDispatchToProps = {
  setUiPopupState,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(UIPopup)
)
